<main id="main-content" class="main-content">
  <h2 class="form-header">{{page()}}. Forest Unit Line Officer Approvals</h2>

  <mat-card>
    @if (report()) {
      <div class="contact-container">
        @for (forest of report().forests; track forest) {
          <div>
            <div class="text-div">
              <b>{{ forest.forest_name }}</b>
            </div>
            @if (forest.line_officer) {
              <mat-card class="contact-card">
                <div>
                  <div class="user-cell-name">
                    <div class="user-icon">
                      <p>{{forest.line_officer.first_name[0]}}</p>
                    </div>
                    <a [routerLink]="['/user']" [queryParams]="{user_id: forest.line_officer?.user_id}"
                    class="user-name">{{forest.line_officer.first_name + " " + forest.line_officer.last_name}}</a>
                  </div>
                  <div class="user-cell-details">
                    @for (role of forest.line_officer.showRoles; track role) {
                      <mat-chip>{{ role }}</mat-chip>
                    }
                    <div class="details-number"><mat-icon>phone</mat-icon> {{(forest.line_officer.phone_num | phone) ||
                    "--"}}
                  </div>
                  <div class="details-email"><mat-icon>email</mat-icon>{{forest.line_officer.email}}</div>
                  <div class="details-email"><mat-icon>location_on</mat-icon>{{ forest.forest_name }}</div>
                </div>
              </div>
            </mat-card>
          }
        </div>
      }
    </div>
  }
</mat-card>
</main>